// extracted by mini-css-extract-plugin
module.exports = {"accordion_open":"accordion_accordion_open__IUByo","accordion__box":"accordion_accordion__box__Ma2eD","accordion__body":"accordion_accordion__body__ropax"};